// extracted by mini-css-extract-plugin
export default {"root":"PlasmicUploadCsv_root__O75qd","text":"PlasmicUploadCsv_text__vvWe9"};